import { render, staticRenderFns } from "./RotateFlip.vue?vue&type=template&id=fbafc200&lang=pug&"
import script from "./RotateFlip.vue?vue&type=script&lang=ts&"
export * from "./RotateFlip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RotateFlip.vue"
export default component.exports